<div class="bg-body text-body" data-bs-theme="dark">
  <div class="container">
    <div class="d-flex align-items-center justify-content-between gap-4 py-3">
      <app-user />
      <app-localize />
    </div>
  </div>
</div>